// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zp-W","colBig":"styles_colBig__3KEXd","colSmall":"styles_colSmall__1aIfO"};